// extracted by mini-css-extract-plugin
export default {"root":"root--9f1055d","ingredient":"ingredient--a6e7b97","suggestions":"suggestions--e74e031"};